const validateTicketCount = (count = 0, setError) => {
  if (count <= 0) {
    setError((prev) => ({ ...prev, count: 'Ticket count cannot be zero or empty.' }));
  } else if (count > 10) {
    setError((prev) => ({ ...prev, count: 'Ticket count cannot be higher than 10.' }));
  } else {
    setError((prev) => ({ ...prev, count: '' }));
    return true;
  }

  return false;
};

const validateTicketPrice = (price, setError, verificationData) => {
  if (!price || price <= 0) {
    setError((prev) => ({ ...prev, price: 'Ticket price cannot be zero or empty.' }));
  } else if (price > (verificationData?.totalPrice / verificationData?.quantity)) {
    setError((prev) => ({ ...prev, price: 'Ticket price cannot be higher than the original price.' }));
  } else {
    setError((prev) => ({ ...prev, price: '' }));
    return true;
  }

  return false;
};

const validateName = (name) => {
  if (!name) {
    setError((prev) => ({ ...prev, name: 'Name cannot be empty.' }));
  } else if (!/^[A-Z][a-z]*(?: [A-Z][a-z]*)*$/.test(name)) {
    setError((prev) => ({ ...prev, name: 'Name must be in Pascal case.' }));
  } else {
    setError((prev) => ({ ...prev, name: '' }));
  }
};

const validateEmail = (email, error, setError) => {
  if (!email) {
    setError((prev) => ({ ...prev, email: 'Email cannot be empty.' }));
  } else if (!/\S+@\S+\.\S+/.test(email)) {
    setError((prev) => ({ ...prev, email: 'Invalid email format.' }));
  } else {
    setError((prev) => ({ ...prev, email: '' }));
  }
};

const validatePhone = (phone, error, setError) => {
  if (!phone) {
    setError((prev) => ({ ...prev, phone: 'Phone number cannot be empty.' }));
  } else if (!/^\d{10}$/.test(phone)) {
    setError((prev) => ({ ...prev, phone: 'Phone number must be 10 digits.' }));
  } else {
    setError((prev) => ({ ...prev, phone: '' }));
  }
};

export {
  validateName,
  validateEmail,
  validatePhone,
  validateTicketCount,
  validateTicketPrice,
};
